import React, { Component, createRef } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { ActionCreator } from "actions";
import { fromJS } from "immutable";
import { ReactComponent as PreviousIcon } from "assets/icons/previous.svg";
import { ReactComponent as CloseIcon } from "assets/icons/close.svg";
import { getTotalPool } from "utils/getTotalpool";
import { isEmpty } from "lodash";
import { withNamespaces } from "react-i18next";
import { InfoAction } from "component/details";

import * as queryString from "query-string";

import "containers/GameActionCollapse/styles.scss";

const ACTION_COLLPSE_MODAL = "ACTION_COLLPSE_MODAL";

class GameActionCollapse extends Component {
  constructor(props) {
    super(props);

    this.modalRef = createRef();
    this.modalActionRef = createRef();
    this.modalCollpaseContentRef = createRef();
    this.modalCollpaseRootRef = createRef();
    this.getTotalPool = getTotalPool.bind(this);
    this.onCloseClickHandler = this._onCloseClickHandler.bind(this);
    this.onExpandDetails = this._onExpandDetails.bind(this);
    this.onGameItemClickHandler = this._onGameItemClickHandler.bind(this);
    this.onClickEventHandler = this._onClickEventHandler.bind(this);
    this.getDetails = this._getDetails.bind(this);
    this.fetchGameUrl = this._fetchGameUrl.bind(this);
    this.handleScroll = this._handleScroll.bind(this);

    this.state = {
      isLoading: true,
      isLoadingRelated: true,
      loadingGameRel: null,
      details: null,
      relatedLinks: null,
      similarLink: null,
      launchRealLink: null,
      launchDemoLink: null,
      realUrl: null,
      demoUrl: null,
      realLink: null,
      demoLink: null,
      expand: false,
      hasPromotionIcons: null,
      showCategoryLabel: false,
      jackpotPool: null,
    };
  }

  _getDetails(gameId) {
    this.setState({
      isLoading: true,
      isLoadingRelated: true,
      loadingGameRel: null,
      details: null,
      relatedLinks: null,
      similarLink: null,
      launchRealLink: null,
      launchDemoLink: null,
      realUrl: null,
      demoUrl: null,
      realLink: null,
      demoLink: null,
      hasPromotionIcons: null,
      showCategoryLabel: false,
    });

    this.props
      .fetchGameDetailsUrl(gameId)
      .then((response) => {
        let link = fromJS(response);
        return this.props.fetchGameDetails(link);
      })
      .then((response) => {
        let details = fromJS(response.payload.data);
        let hasPromotionIcons =
          details.get("hasFreeRounds") ||
          details.get("partOfOnGoingTournament") ||
          details.get("isFeatured") ||
          details.get("isJackpot");
        this.setState({
          details,
          hasPromotionIcons,
        });
        return;
      })
      .then(() => {
        let realLink;
        try {
          realLink = this.state.details.get("links").find((link) => {
            return link.get("rel") === "launch.real";
          });
        } catch (err) {}
        this.setState({
          realLink,
        });
      })
      .then(() => {
        let demoLink;
        try {
          demoLink = this.state.details.get("links").find((link) => {
            return link.get("rel") === "launch.demo";
          });
          this.setState({
            demoLink,
          });
        } catch (err) {
          return;
        }
      })
      .then(() => {
        this.setState({
          isLoading: false,
          isLoadingRelated: false,
        });
      });
  }

  async _onClickEventHandler(link) {
    let url;
    const newWindow = window.open("", this.props.gameLaunchTarget); // Open immediately

    this.setState({
      loadingGameRel: link.get("rel"),
    });

    await this.fetchGameUrl(link);

    switch (link.get("rel")) {
      case "launch.real":
        url = this.state.realUrl;
        break;
      case "launch.demo":
        url = this.state.demoUrl;
        break;
      default:
        url = null;
        break;
    }

    if (url) {
      newWindow.location.href = url;
    } else {
      newWindow.close();
    }

    this.setState({
      loadingGameRel: null,
    });
  }

  _fetchGameUrl(link) {
    let params;
    let returnUrl;
    switch (this.props.gameLaunchTarget) {
      case "_top":
      case "_parent":
      case "_self":
        let urlParams = new URLSearchParams(this.props.location.search);
        let redirectParams = new URLSearchParams();
        let url = `${this.props.location.pathname}?${urlParams.toString()}`;
        redirectParams.set("redirect", btoa(encodeURIComponent(url)));
        returnUrl = `${window.location.origin}/${
          this.props.match.params.locale
        }/${
          this.props.match.params.sessionId
        }/exit?${redirectParams.toString()}`;
        break;
      default:
        returnUrl = `${window.location.origin}/${
          this.props.match.params.locale
        }/${this.props.match.params.sessionId}/exit`;
        break;
    }
    params = {
      returnUrl,
    };

    if (this.props.appId) {
      params = {
        returnUrl: `${this.props.appId}://lobby`,
      };
    }

    return this.props
      .fetchGameUrl(link, params)
      .then((response) => {
        if (link.get("rel") === "launch.real") {
          this.setState({
            launchRealLink: link,
            realUrl: response.payload.data.url,
          });
        } else if (link.get("rel") === "launch.demo") {
          this.setState({
            launchDemoLink: link,
            demoUrl: response.payload.data.url,
          });
        }
        return response;
      })
      .catch((err) => {
        this.setState({
          loadingGameRel: null,
        });
      });
  }

  _onGameItemClickHandler(game, rel) {
    this.setState({
      loadingGameRel: null,
    });
    let gameId = game.get("gameId");
    let nav = this.props.nav;
    this.props.gameClick(gameId, rel, nav).then((response) => {
      if (response.location) {
        this.props.navigateTo(response.location);
      } else if (response.params) {
        this.props.setGameAction(response.params);
      }
    });
    this.props.clearGameAction();
  }

  _onExpandDetails() {
    this.setState({
      expand: !this.state.expand,
    });
  }

  _onCloseClickHandler() {
    this.setState({
      expand: false,
    });
    this.props.fetchBalance();
    let search = queryString.parse(this.props.location.search);
    delete search.gameId;
    delete search.playType;
    delete search.nav;
    this.props.navigateTo(`${this.props.location.pathname}`);
  }

  componentDidMount() {
    this.initObserver();
  }

  componentWillReceiveProps(nextProps) {
    if (this.props.gameAction !== nextProps.gameAction) {
      if (nextProps.gameAction === null) {
        this.props.hideModal(ACTION_COLLPSE_MODAL);
        this.setState({
          expand: false,
        });
      } else {
        this.setState({
          complete: false,
        });
        this.getDetails(nextProps.gameAction.get("gameId"));
        this.props.showModal(ACTION_COLLPSE_MODAL);
      }
    }
    if (
      nextProps.gameActionDetails &&
      this.props.gameActionDetails !== nextProps.gameActionDetails
    ) {
    }
    if (
      this.state.details &&
      nextProps.latestBroadcast &&
      nextProps.latestBroadcast.get("jackpotGroupId") ===
        this.state.details.get("jackpotGroupId")
    ) {
      let latestJackpotPool;
      latestJackpotPool = {
        type: nextProps.latestBroadcast.get("type"),
        amount: nextProps.latestBroadcast.get("amount"),
      };
      this.setState({
        jackpotPool: {
          ...this.state.jackpotPool,
          [latestJackpotPool.type]: { amount: latestJackpotPool.amount },
        },
      });
    } else {
      this.setState({ jackpotPool: null });
    }
  }

  _handleScroll(event) {
    const { scrollTop } = event.currentTarget;
    if (scrollTop !== 0) {
      this.setState({ showCategoryLabel: true });
    } else {
      this.setState({ showCategoryLabel: false });
    }
  }

  initObserver() {
    if (
      "IntersectionObserver" in window &&
      "IntersectionObserverEntry" in window &&
      "intersectionRatio" in window.IntersectionObserverEntry.prototype
    ) {
      let observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (!entry.isIntersecting && this.props.gameAction) {
              let newLoc = `${
                this.props.location.pathname
              }?${queryString.stringify(this.props.gameAction.toJSON())}`;
              this.props.setGameActionDetails(this.state);
              this.props.navigateTo(newLoc);
              this.props.clearGameAction();
              this.setState({
                expand: false,
              });
            }
          });
        },
        {
          //root: this.modalCollpaseRootRef.current,
          rootMargin: "0px 0px 0px 0px",
        },
      );
      observer.observe(this.modalCollpaseContentRef.current);
    } else {
      this.getGames(this.props.link);
      this.getTournamentPreview(this.props.links);
    }
  }

  render() {
    const { t } = this.props;
    return (
      <div
        className={`game-action-collapse modal ${
          this.props.gameAction ? "show" : ""
        } ${this.state.expand ? "expand" : ""} ${
          this.state.complete ? "complete" : ""
        }`}
        onClick={() => {
          if (this.state.loadingGameRel) return;
          this.props.clearGameAction();
        }}
      >
        <div
          className="modal-dialog nopadding"
          onClick={(event) => {
            event.stopPropagation();
          }}
        >
          <div className="modal-content">
            <div
              className="modal-observer"
              ref={this.modalCollpaseContentRef}
            />
            <div
              className="modal-body nopadding"
              ref={this.modalActionRef}
              onScroll={this.handleScroll}
            >
              <div
                className="header-game-action"
                disabled={this.state.loadingGameRel !== null}
              >
                {!this.state.expand && !this.state.isLoading && (
                  <button
                    className="more"
                    onClick={this.onExpandDetails}
                    disabled={this.state.loadingGameRel !== null}
                  >
                    {t("more")}
                  </button>
                )}
                {!this.state.expand &&
                  (this.state.isLoading || this.state.isLoadingRelated) && (
                    <span className="more">
                      <span className="dummy">XXXX</span>
                    </span>
                  )}
                {this.state.expand && (
                  <PreviousIcon
                    onClick={this.props.history.goBack}
                    disabled={this.state.loadingGameRel !== null}
                  />
                )}
                {!this.state.expand &&
                  !this.state.isLoading &&
                  !this.state.isLoadingRelated && (
                    <button
                      className="horizontal-bar"
                      onClick={this.onExpandDetails}
                      disabled={this.state.loadingGameRel !== null}
                    >
                      &nbsp;
                    </button>
                  )}
                {!this.state.expand && (
                  <button
                    className="close-btn"
                    onClick={this.props.clearGameAction}
                    disabled={this.state.loadingGameRel !== null}
                  >
                    {t("close")}
                  </button>
                )}
                {this.state.details && this.state.expand && (
                  <span
                    className={`details-actions ${
                      this.state.showCategoryLabel ? "" : ""
                    }`}
                    ref={this.actionLabel}
                  >
                    {this.state.details.get("name")}
                  </span>
                )}
                {this.state.expand && (
                  <CloseIcon onClick={this.onCloseClickHandler} />
                )}
              </div>
              <div className="image-spacer" />
              <InfoAction
                details={this.state.details}
                imageFormat={this.props.imageFormat}
                isLoading={this.state.isLoading}
                demoLink={this.state.demoLink}
                realLink={this.state.realLink}
                hasPromotionIcons={this.state.hasPromotionIcons}
                currency={this.props.currency}
                jackpotPool={this.state.jackpotPool}
                loadingGameRel={this.state.loadingGameRel}
                gameLaunchTarget={this.props.gameLaunchTarget}
                compact={!this.state.expand}
                onGameItemClickHandler={(rel) => {
                  this.onGameItemClickHandler(this.state.details, rel);
                }}
                onClickEventHandler={(link) => {
                  this.onClickEventHandler(link);
                }}
              />
            </div>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  let params;
  let gameId;
  let nav;
  let playType;
  let gameLaunchTarget;
  let currency = null;
  let latestBroadcast;
  let realLink;
  let demoLink;
  let game;

  try {
    latestBroadcast = state.serverSentEvent.getIn(["latestBroadcast"]);
  } catch (err) {}

  try {
    params = state.game.get("params");
  } catch (err) {}

  try {
    game = params.get("game");
  } catch (err) {}

  try {
    realLink = game.getIn(["links"]).find((link) => {
      return link.get("rel") === "launch.real";
    });
  } catch (err) {}

  try {
    demoLink = game.getIn(["links"]).find((link) => {
      return link.get("rel") === "launch.demo";
    });
  } catch (err) {}

  try {
    nav = params.get("nav");
  } catch (err) {}

  try {
    playType = params.get("playType");
  } catch (err) {}

  try {
    gameId = params.get("gameId");
  } catch (err) {}

  try {
    gameLaunchTarget = state.links.get("gameLaunchTarget");
  } catch (err) {}

  if (!isEmpty(state.links.get("currency"))) {
    currency = state.links.get("currency");
  }

  return {
    playType,
    gameLaunchTarget,
    nav,
    realLink,
    demoLink,
    gameId,
    gameAction: state.game.get("params"),
    gameActionDetails: state.game.get("stateDetails"),
    isMobile: state.window.get("isMobile"),
    currency: currency,
    latestBroadcast,
    imageFormat: state.window.get("imageFormat"),
    locale: state.config.getIn(["locale"]),
  };
};

const mapDispatchToProps = (dispatch, ownProps) => {
  return bindActionCreators(ActionCreator, dispatch);
};

const mergeProps = (stateProps, dispatchProps, ownProps) => {
  return Object.assign({}, stateProps, ownProps, {
    fetchGameDetailsUrl: (gameId) => dispatchProps.fetchGameDetailsUrl(gameId),
    fetchGameDetails: (link, params) =>
      dispatchProps.fetchGameDetails(link, params),
    fetchGameUrl: (link, params) => dispatchProps.fetchGameUrl(link, params),
    fetchRelatedLinks: (route, params) =>
      dispatchProps.fetchRelatedLinks(route, params),
    fetchGames: (route, params) => dispatchProps.fetchGames(route, params),
    navigateTo: (path) => ownProps.history.push(`${path}`),
    showModal: (modal) => dispatchProps.showModal(modal),
    hideModal: (modal) => dispatchProps.hideModal(modal),
    fetchBalance: () => dispatchProps.fetchBalance(),
    clearGameAction: () => dispatchProps.clearGameAction(),
    setGameActionDetails: (payload) =>
      dispatchProps.setGameActionDetails(payload),
    onGameLaunch: (params) => dispatchProps.onGameLaunch(params),
    gameClick: (gameId, playType, nav) =>
      dispatchProps.gameClick(gameId, playType, nav),
  });
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
  mergeProps,
)(withNamespaces("translation")(GameActionCollapse));
